import { ResourceEnum } from '../../../enums';

export class GetActivejobsArgs {
    resource?: ResourceEnum;
}
